"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralRu3 = exports.pluralRu2 = exports.pluralRu1 = exports.orderRu3 = exports.orderRu2 = exports.orderRu1 = exports.scoreFn = exports.withParentheses = exports.withPlus = void 0;
const i18next_1 = __importDefault(require("i18next"));
const withPlus = () => {
    return (text, render) => {
        const value = render(text);
        if (!value.startsWith('-') && Number(value) !== 0) {
            return `+${value}`;
        }
        return value;
    };
};
exports.withPlus = withPlus;
const withParentheses = () => {
    return (text, render) => {
        return `(${render(text)})`;
    };
};
exports.withParentheses = withParentheses;
const scoreFn = () => {
    return (text, render) => {
        const value = render(text);
        const [homeScore, awayScore] = value.split(' ');
        if (homeScore === '-1' && awayScore === '-1') {
            return i18next_1.default.t('anyOther') || 'any other';
        }
        return `${homeScore}:${awayScore}`;
    };
};
exports.scoreFn = scoreFn;
// гол, очко, сет, гейм, иннинг, карта, половина, квотер, период, фрейм
// 0-ой, 1-ый гол/сет..., 2-ой гол, 3-ий гол, 4-ый гол, 5-ый гол, 6-ой гол, 7-ой гол, 8-ой гол, 9-ый гол, 10-ый, 11-ый
const orderRu1 = () => {
    return (text, render) => {
        const value = Number(render(text));
        const valueModule = value < 0 ? -value : value;
        if (valueModule >= 10 && valueModule <= 20) {
            return `${value}-ый`;
        }
        const mod = valueModule % 10;
        switch (mod) {
            case 0:
            case 2:
            case 6:
            case 7:
            case 8:
                return `${value}-ой`;
            case 3:
                return `${value}-ий`;
            default:
                return `${value}-ый`;
        }
    };
};
exports.orderRu1 = orderRu1;
// 0-ое, 1-ое очко, 2-ое, 3-ье, 4-ое, 5-ое, 6-ое, 7-ое, 8-ое, 9-ое, 10-ое
const orderRu2 = () => {
    return (text, render) => {
        const value = Number(render(text));
        const valueModule = value < 0 ? -value : value;
        const mod = valueModule % 10;
        if (mod === 3)
            return `${value}-ье`;
        return `${value}-ое`;
    };
};
exports.orderRu2 = orderRu2;
// 0-ая, 1-ая карта/половина, 2-ая, 3-ья, 4-ая, 5-ая, 6-ая, 7-ая, 8-ая, 9-ая, 10-ая, 11-ая, 12-ая ...
const orderRu3 = () => {
    return (text, render) => {
        const value = Number(render(text));
        const valueModule = value < 0 ? -value : value;
        const mod = valueModule % 10;
        if (mod === 3)
            return `${value}-ья`;
        return `${value}-ая`;
    };
};
exports.orderRu3 = orderRu3;
// 0 гол-ов, 1 гол, 2 гол-а, 3 гол-а, 4 гол-а, 5 гол-ов, 6 гол-ов, 7 гол-ов, 8 гол-ов, 9 гол-ов, 10 гол-ов
// 20 гол-ов, 21 гол, 22 гол-а, 23 гол-а...
const pluralRu1 = () => {
    return (text, render) => {
        const value = render(text);
        const [count, unit] = value.split(' ');
        const countNumber = Number(count);
        const countNumberModule = countNumber < 0 ? -countNumber : countNumber;
        if (countNumberModule >= 10 && countNumberModule <= 20) {
            return `${countNumber} ${unit}ов`;
        }
        const mod = countNumberModule % 10;
        switch (mod) {
            case 1:
                return `${countNumber} ${unit}`;
            case 2:
            case 3:
            case 4:
                return `${countNumber} ${unit}а`;
            default:
                return `${countNumber} ${unit}ов`;
        }
    };
};
exports.pluralRu1 = pluralRu1;
// очко
// 0 очков, 1 очко, 2 очка, 3 очка, 4 очка, 5 очков, 6 очков, 7 очков, 8 очков, 9 очков, 10 очков
// 20 очков, 21 очко, 22 очка, 23 очка
const pluralRu2 = () => {
    return (text, render) => {
        const value = render(text);
        const [count, unit] = value.split(' ');
        const countNumber = Number(count);
        const countNumberModule = countNumber < 0 ? -countNumber : countNumber;
        if (countNumberModule >= 10 && countNumberModule <= 20) {
            return `${countNumber} ${unit}в`;
        }
        const mod = countNumberModule % 10;
        switch (mod) {
            case 1:
                return `${countNumber} ${unit}`;
            case 2:
            case 3:
            case 4:
                return `${countNumber} ${unit.substring(0, unit.length - 1)}а`;
            default:
                return `${countNumber} ${unit}в`;
        }
    };
};
exports.pluralRu2 = pluralRu2;
// карта
// 0 карт, 1 карта, 2 карты, 3 карты, 4 карты, 5 карт, 6 карт, 7 карт, 8 карт, 9 карт, 10 карт
// 20 карт, 21 карта, 22 карты, 23 карты
const pluralRu3 = () => {
    return (text, render) => {
        const value = render(text);
        const [count, unit] = value.split(' ');
        const countNumber = Number(count);
        const countNumberModule = countNumber < 0 ? -countNumber : countNumber;
        if (countNumberModule >= 10 && countNumberModule <= 20) {
            return `${countNumber} ${unit.substring(0, unit.length - 1)}`;
        }
        const mod = countNumberModule % 10;
        switch (mod) {
            case 1:
                return `${countNumber} ${unit}`;
            case 2:
            case 3:
            case 4:
                return `${countNumber} ${unit.substring(0, unit.length - 1)}ы`;
            default:
                return `${countNumber} ${unit.substring(0, unit.length - 1)}`;
        }
    };
};
exports.pluralRu3 = pluralRu3;
//# sourceMappingURL=customizationFunctions.js.map